export { default, type AccordionProps } from './Accordion';
